import moment from 'moment';
import { IDateRange, TDetailTabs, TVitalRecordType } from '../../../../types/life-id';

export default function getPayloadMap(
  dateRange: IDateRange,
  recordType: TVitalRecordType,
  userId: string,
  providerId: string,
) {
  return new Map<TDetailTabs, any>([
    [
      'day',
      {
        dateFrom: dateRange.from ? dateRange.from : moment().startOf('day').toISOString(),
        dateTo: dateRange.to ? dateRange.to : moment().endOf('day').toISOString(),
        step: 'hour',
        type: recordType,
        userId,
        providerId,
      },
    ],
    [
      'week',
      {
        dateFrom: dateRange.from
          ? dateRange.from
          : moment().subtract(7, 'day').startOf('day').toISOString(),
        dateTo: dateRange.to ? dateRange.to : moment().endOf('day').toISOString(),
        step: 'day',
        type: recordType,
        userId,
        providerId,
      },
    ],
    [
      'month',
      {
        dateFrom: dateRange.from ? dateRange.from : moment().subtract(1, 'month').toISOString(),
        dateTo: dateRange.to ? dateRange.to : moment().endOf('day').toISOString(),
        step: 'day',
        type: recordType,
        userId,
        providerId,
      },
    ],
    [
      'year',
      {
        dateFrom: dateRange.from ? dateRange.from : moment().subtract(1, 'year').toISOString(),
        dateTo: dateRange.to ? dateRange.to : moment().endOf('day').toISOString(),
        step: 'month',
        type: recordType,
        userId,
        providerId,
      },
    ],
  ]);
}
